import React, { useEffect, useState } from 'react';
import './slideshow.scss';

export interface SlideItem {
  src: string;
  alt: string;
}

interface SlideshowProps {
  slides?: SlideItem[];
  intervalMs?: number;
}

const defaultSlides: SlideItem[] = [
  { src: '/photo/luchtvanheerde1.jpg', alt: 'Luchtfoto van Heerde bij zonsondergang' },
  { src: '/photo/luchtvanheerde2.jpg', alt: 'Dronebeeld van landschap rondom Heerde' },
  { src: '/photo/luchtvanheerde3.jpg', alt: 'Overzicht van dorp en groene omgeving' },
  { src: '/photo/luchtvanheerde4.jpg', alt: 'Rustige luchtfoto met lange schaduwen' },
  { src: '/photo/luchtvanheerde5.jpg', alt: 'Panoramisch beeld van de omgeving van Heerde' }
];

const Slideshow: React.FC<SlideshowProps> = ({
  slides = defaultSlides,
  intervalMs = 6000
}) => {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    if (slides.length < 2) {
      return;
    }

    const interval = window.setInterval(() => {
      setActiveIndex((prevIndex) => (prevIndex + 1) % slides.length);
    }, intervalMs);

    return () => window.clearInterval(interval);
  }, [slides.length, intervalMs]);

  if (slides.length === 0) {
    return null;
  }

  const goToPrevious = () => {
    setActiveIndex((prevIndex) => (prevIndex - 1 + slides.length) % slides.length);
  };

  const goToNext = () => {
    setActiveIndex((prevIndex) => (prevIndex + 1) % slides.length);
  };

  const blockImageDownloadActions = (event: React.SyntheticEvent) => {
    event.preventDefault();
  };

  return (
    <div className="photo-slideshow" role="region" aria-label="Fotogalerij slideshow">
      <div className="slideshow-frame">
        <div className="slideshow-image-wrapper" onContextMenu={blockImageDownloadActions}>
          <img
            src={slides[activeIndex].src}
            alt={slides[activeIndex].alt}
            className="slideshow-image"
            loading={activeIndex === 0 ? 'eager' : 'lazy'}
            draggable={false}
            onDragStart={blockImageDownloadActions}
            onContextMenu={blockImageDownloadActions}
          />
          <div
            className="image-protection-layer"
            aria-hidden="true"
            onContextMenu={blockImageDownloadActions}
            onDragStart={blockImageDownloadActions}
          />
          <button
            type="button"
            className="image-nav-button image-nav-prev"
            aria-label="Vorige foto"
            onClick={goToPrevious}
          >
            &#8249;
          </button>
          <button
            type="button"
            className="image-nav-button image-nav-next"
            aria-label="Volgende foto"
            onClick={goToNext}
          >
            &#8250;
          </button>
        </div>
      </div>
    </div>
  );
};

export default Slideshow;